import { ApiRequest, RequestMethod } from "../../request";

export async function addInjury(
  fighterId: string,
  injuryId: string,
): Promise<boolean> {
  const apiRequest = new ApiRequest();

  const URL = `/api/fighter/${fighterId}/add-injury`;

  apiRequest.setMethod(RequestMethod.POST);
  apiRequest.setUrl(URL);

  apiRequest.setJsonBody({
    injuryId: injuryId,
  });

  const response: any = await apiRequest.send();

  return response.status === 200;
}
